import { BaseInput } from "../primitive/BaseInput";
import { TextInputProps } from "./TextInput";

export interface PasswordInputProps extends TextInputProps {};

export const PasswordInput = (props: PasswordInputProps) => {
    return (
        <BaseInput
            type="password"
            {...props}
            onValueChange={val => props.onValueChange(String(val))}
        />
    )
}